import {
  ApolloClient,
  ApolloProvider as Provider,
} from "@apollo/client";
import { FC, PropsWithChildren } from "react";
import link, { kekLink, placeItLink } from "./link";

import cache from "./cache";
import config from "config";
import { getDomain } from "router/filter";

// import schema from "./schema";
// import schema from "./schema";

export const client = new ApolloClient({
  link: link,
  name: config.apollo.name,
  version: config.apollo.version,
  headers: {
    'client-name': config.apollo.name,
    'client-version': config.apollo.version,
  },
  cache: cache,
  connectToDevTools: config.env === "development"
});
export const kekClient = new ApolloClient({
  link: kekLink,
  name: config.apollo.name,
  version: config.apollo.version,
  headers: {
    'client-name': config.apollo.name,
    'client-version': config.apollo.version,
  },
  cache: cache,
  connectToDevTools: config.env === "development"
});

export const placeItClient = new ApolloClient({
  link: placeItLink,
  name: config.apollo.name,
  version: config.apollo.version,
  headers: {
    'client-name': config.apollo.name,
    'client-version': config.apollo.version,
  },
  cache: cache,
});

const ApolloProvider: FC<PropsWithChildren> = ({ children }) => {
  const domain = getDomain()
  return (
    <Provider client={domain === "KEK" ? kekClient : client}>
      {children}
    </Provider>
  )
}

export default ApolloProvider